import Instance from '../../../../utils/Axios';

const EnviarValidacaoAD = (ydata, setValidarBtn) => async (dispatch) => {
  const stateToken = localStorage.token;

  if (stateToken) {
    await Instance()
      .post('/obras/validacao/administradores/direta', { ydata })
      .then(({ data }) => {
        console.log(data);
        setValidarBtn(true);
        if (stateToken) {
          dispatch({ type: 'POST_VALIDACAO_AD', payload: data });
        }
      })
      .catch(({ err }) => console.log(err));
  }
};

export default EnviarValidacaoAD;
